import { API_ENDPOINTS } from '@/constants/api';
import type { EntityEndpoints } from '@/shared/types/entity';

export const ENTITY_CONFIGS = {
  banners: {
    name: 'banners',
    displayName: 'Banners',
    endpoints: API_ENDPOINTS.BANNERS as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null, status: 'all' },
    skipLoaderForSearch: true,
    readOnlyForRoles: [],
  },
  discounts: {
    name: 'discounts',
    displayName: 'Subscription Discounts',
    endpoints: API_ENDPOINTS.DISCOUNTS as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null },
    skipLoaderForSearch: true,
    readOnlyForRoles: [],
  },
  roles: {
    name: 'roles',
    displayName: 'Roles',
    endpoints: API_ENDPOINTS.ROLES as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null },
    skipLoaderForSearch: true,
    readOnlyForRoles: [],
  },
  users: {
    name: 'users',
    displayName: 'Users',
    endpoints: API_ENDPOINTS.USERS as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null, role: '', status: undefined },
    skipLoaderForSearch: true,
    readOnlyForRoles: ['readonly', 'readwrite'],
  },
  paymentRetries: {
    name: 'paymentRetries',
    displayName: 'Payment Retries',
    endpoints: API_ENDPOINTS.PAYMENT_RETRIES as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null, shopifyCustomerId: '' },
    skipLoaderForSearch: true,
    readOnlyForRoles: ['readonly'],
  },
  customers: {
    name: 'customers',
    displayName: 'Customers',
    endpoints: {} as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null },
    skipLoaderForSearch: true,
    readOnlyForRoles: ['readonly', 'readwrite'],
  },
  auditLogs: {
    name: 'auditLogs',
    displayName: 'Audit Logs',
    endpoints: API_ENDPOINTS.AUDIT_LOGS as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null, entityType: '', action: '' },
    skipLoaderForSearch: true,
    readOnlyForRoles: [],
  },
  replacementBatches: {
    name: 'replacementBatches',
    displayName: 'Replacement Batches',
    endpoints: API_ENDPOINTS.REPLACEMENT_BATCHES as EntityEndpoints,
    defaultFilters: { search: '', dateRange: null },
    skipLoaderForSearch: true,
    readOnlyForRoles: [],
  },
} as const;

export type EntityName = keyof typeof ENTITY_CONFIGS;
